import { lazy } from "react";
import Loadable from "../../layout/fullLayout/loadable/loadable";
import { AuthorizedRoute } from "../../router/AuthorizedRoute";


const WhatsAppQR = Loadable(
	lazy(() =>
		import("./WhatsAppQR").then(({ WhatsAppQR }) => ({
			default: WhatsAppQR,
		}))
	)
);

export const whatsAppQRRoutes = [
    {
        path: "/whatsapp-qr",
        exact: true,
        element: (
            <AuthorizedRoute moduleIds={[]} allowFullAccess>
                <WhatsAppQR />
            </AuthorizedRoute>
        ),
    },
   
];
